import { Pipe } from "@angular/core";

@Pipe({
    name: 'aisleIngredient'
})

export class AisleIngredientPipe {
    transform(value, args?): string {
        if(!value) return value;
        value = value.replace(/_/g, " ").toLowerCase();
        value = value.charAt(0).toUpperCase() + value.slice(1);
        return value;
    }
}
